export const SHOW_LOADING = 'SHOW_LOADING';
export const SET_USER_LOGGED = 'SET_USER_LOGGED';
export const CLEAR_CREDENTIALS = 'CLEAR_CREDENTIALS';
